import { Box, Container, Typography } from "@mui/material";
import GestionTarifas from "../../../components/tarifas/GestionTarifas";
import BannerPreview from "../../../components/evento/BannerPreview";

export const SegundoPaso = ({ eventId, isPublic }) => (
  <Container maxWidth="lg">
    <Box sx={{ mt: 5, mb: 2 }}>
      <Typography sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
        Configurá las tarifas de tu evento según el tipo de acceso o consumición que quieras brindar.
      </Typography>
    </Box>
    <GestionTarifas eventoId={eventId} />
    <Box sx={{ mt: 4, textAlign: "center", fontStyle: "italic", color: "text.secondary" }}>
      <Typography variant="body2">
        Si tu evento es público, las tarifas estarán disponibles una vez vincules tu cartera.
      </Typography>
    </Box>
    {isPublic && eventId && <BannerPreview eventId={eventId} />}
  </Container>
);
